module.exports = __webpack_public_path__ + "fonts/AudiType-ExtendedNormal_4.03.c737145b.woff";